"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("../snippet");
var ProductContent = /** @class */ (function (_super) {
    __extends(ProductContent, _super);
    function ProductContent(props) {
        var _this = _super.call(this, props) || this;
        _this.buildProductDetails = function (_a, _b) {
            var title = _a.title, description = _a.description;
            var sku = _b.sku;
            var _c;
            var codeMatch = _this.props.product.tags.filter(function (tag) { return tag.indexOf("ap21Code:") != -1; });
            return "\n      <span class=\"text-xmd font-semibold text-navy-dark\">" + title + "</span>\n      <hr />\n      " + ((_c = description) === null || _c === void 0 ? void 0 : _c.replace(/\\/g, '')) + "\n      " + (codeMatch && codeMatch.length
                ? "<hr /> \n      <div>Product Code: " + codeMatch[0].split(":")[1] + "</div>\n      "
                : "") + "\n      ";
            // <hr />
            // <div>Product Code: ${sku}</div>
            // <hr />
            // <div>Product SKU: ${sku}</div>
            // to do SKU
        };
        _this.buildList = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement("div", { key: i, className: "w-full lg:py-0 lg:mr-16 lg:w-auto" },
                    React.createElement("h4", { className: "flex flex-row justify-between lg:flex-wrap items-center px-2-4 cursor-pointer group " + (_this.state.active == i ? "lg:pb-0 md:border-b-4 md:border-navy text-navy-dark" : "text-secondary-blue-grey"), onClick: function (event) {
                            _this.toggleOpen(i);
                        } },
                        React.createElement("span", { className: "pt-1-4 pb-1 lg:pt-4-8 lg:leading-2 font-normal text-base no-underline lg:pb-1 lg:w-full" }, link.title),
                        React.createElement(Snippets.Svg, { name: "" + (_this.state.active == i ? "minus" : "plus"), width: 14, className: "lg:hidden" })),
                    _this.state.viewWidth < 767 ? (React.createElement("div", { className: (_this.state.active == i ? "h-auto pb-4" : "h-0 pb-0 ") + " overflow-hidden transition-all" }, _this.buildContent(link, i))) : null)); })
                : [];
        };
        _this.buildContent = function (link, i) { return (React.createElement("div", { className: "text-grey-lighter text-base" },
            React.createElement("div", { className: "w-full lg:flex lg:flex-no-wrap" },
                React.createElement("div", { className: "w-full pb-2 lg:pb-none" }, i === 0 ? (React.createElement("div", { className: "flex flex-col md:flex-row-reverse" },
                    React.createElement("div", { className: "w-full md:w-1/2" }, _this.props.videoContent && React.createElement(Snippets.ProductVideo, __assign({}, _this.props, { content: _this.props.videoContent }))),
                    React.createElement("div", { className: "leading-normal px-1-6 w-full md:w-1/2", dangerouslySetInnerHTML: { __html: "" + link.content } }))) : (React.createElement("div", { className: "leading-normal px-1-6", dangerouslySetInnerHTML: { __html: "" + link.content } })))))); };
        _this.buildDesk = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement("div", { key: i, className: "" + (_this.state.active == i ? "h-auto pt-1" : "h-0 overflow-hidden") }, _this.buildContent(link, i))); })
                : [];
        };
        _this.state = {
            active: window.innerWidth >= 992 ? 0 : -1,
            sections: _this.populateTabs(_this.props.content),
            viewWidth: window.outerWidth,
            expanded: false
        };
        return _this;
    }
    ProductContent.prototype.populateTabs = function (content) {
        var tabs = [];
        if (this.props.product.hasOwnProperty("description") && this.props.product.description) {
            tabs.push({ title: "Product Details", content: this.buildProductDetails(this.props.product, this.props.variant) });
        }
        if (content.delivery_returns) {
            tabs.push({ title: "Delivery & Returns", content: "" + content.delivery_returns });
        }
        return tabs;
    };
    ProductContent.prototype.render = function () {
        return (React.createElement("nav", { className: (this.props.outerClass ? this.props.outerClass : "") + " w-full flex flex-wrap text-left bg-arctic" },
            React.createElement("div", { className: "w-full flex flex-wrap text-left lg:flex-no-wrap lg:justify-start lg:mb-3 border-b-2 border-secondary-blue-grey" }, this.buildList(this.state.sections)),
            React.createElement("div", { className: "w-full hidden md:block" },
                React.createElement("div", { className: "w-full" }, this.buildDesk(this.state.sections)))));
    };
    ProductContent.prototype.toggleOpen = function (nextModal) {
        this.setState({
            active: nextModal == this.state.active ? -1 : nextModal,
            expanded: false
        });
    };
    ProductContent.prototype.toggleExpand = function () {
        this.setState({
            expanded: !this.state.expanded
        });
    };
    return ProductContent;
}(React.PureComponent));
exports.ProductContent = ProductContent;
